/* Quando una risposta del server dice «questa sessione non vale piu'».

   Nasce da un blocco vero (07/10/2026): l'app agente, con un token scaduto o assente,
   mostrava «Non riesco a contattare il servizio» e non tornava al login. Il servizio
   stava benissimo — mancava la sessione. Capita anche aprendo l'app da un indirizzo
   diverso dal solito: il token vive nello spazio di QUEL sito, quindi altrove non c'e'. */

export function sessioneScaduta(errore) {
  return (errore && errore.response && errore.response.status) === 401;
}

/* 403 e' un'altra cosa: l'account c'e' ma non e' abilitato a quella funzione (o e' stato
   disattivato). Li' il login non serve, serve parlare col referente. */
export function nonAutorizzato(errore) {
  return (errore && errore.response && errore.response.status) === 403;
}
